import * as React from "react";

import "./drawing-rect-mode.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";
import {chain}    from "@Common/utils/fs";

import {addVector}        from "../../../common/add-vector";
import {applyAspectRatio} from "../../../common/apply-aspect-ratio";
import {Dragging}         from "../../../common/dragging";
import {inSize}           from "../../../common/in-size";
import {multiplySize}     from "../../../common/multiply-size";
import {multiplyVector}   from "../../../common/multiply-vector";
import {pointsToRect}     from "../../../common/points-to-rect";
import {roundSize}        from "../../../common/round-size";
import {roundVector}      from "../../../common/round-vector";
import {subtractVector}   from "../../../common/subtract-vector";

import {HighlightRect} from "./highlight-rect/highlight-rect";

export const DrawingRectMode = ({aspectRatio, next}) => cs(

    ({}) => next({
        render: ({frame, desktop, getBgColor, onDone}) =>  cs(
            ["state2", (_, next) => UseState({next})],
            ["dragging", (_, next) => Dragging({next})],
            ["getRect", ({state2}, next) => next((delta) => {
                const size = roundSize(multiplySize(frame.size, 1 / frame.ratio));
                const p1 = inSize(
                    state2.value.pos1,
                    size,
                );
                const p2 = inSize(
                    addVector(state2.value.pos1, delta),
                    size,
                );

                return chain(
                    (() => {
                        if (aspectRatio == null) {
                            return p2;
                        }
                        return applyAspectRatio({p2, p1, aspectRatio, size});

                        // return farthestPoint2;
                    })(),
                    (p2) => pointsToRect(p1, p2),
                );
            })],
            ({dragging, state2, getRect}) => (
                <div {...{
                    className: "drawing-rect-mode-52k",
                    ...dragging.handle,
                }}>
                    {dragging.renderActive({
                        onStart: ({oriPos}) => {
                            // console.log(chain(
                            //     subtractVector(oriPos, desktop.getBoundingClientRect()),
                            //     (_) => subtractVector(_, frame.start),
                            //     (_) => multiplyVector(_, 1/frame.ratio),
                            //     roundVector,
                            //     // (_) => inRect(_, {x:0,y:0}, frame.size),
                            // ))
                            state2.onChange({
                                pos1: chain(
                                    subtractVector(oriPos, desktop.getBoundingClientRect()),
                                    (_) => subtractVector(_, frame.start),
                                    (_) => multiplyVector(_, 1/frame.ratio),
                                    roundVector,
                                    // (_) => inRect(_, {x:0,y:0}, frame.size),
                                ),
                            })
                        },
                        modDelta: (delta) => chain(
                            delta,
                            (_) => multiplyVector(_, 1/frame.ratio),
                            roundVector,
                        ),
                        onDone: (delta) => {
                            const rect = getRect(delta);
                            if (rect.width && rect.height) {
                                // console.log(rect, frame.toAbsVpRect(rect));
                                // console.log("rect", rect);
                                onDone(rect);
                            }
                        },
                    })}

                    {/*{HighlightRect({*/}
                    {/*    rect: {x:0,y:0,width: 4, height: 3},*/}
                    {/*    frame,*/}
                    {/*})}*/}
                    {state2.value && dragging.active?.delta && cs(
                        ["rect", (_, next) => next(getRect(
                            dragging.active.delta,
                        ))],
                        ({rect}, next) => !!rect.width && !!rect.height && next(),
                        ({rect}) => (
                            HighlightRect({
                                rect,
                                getBgColor,
                                frame,
                            })
                        ),
                    )}

                </div>
            ),
        ),
    })
);

